// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_a1-0";
export var orangeButton = "_a1-1";